var map = {
	"./old": "./src/theme/old.js",
	"./old.js": "./src/theme/old.js",
	"./standard": "./src/theme/standard.js",
	"./standard.js": "./src/theme/standard.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/theme sync recursive ^\\.\\/.*$";